module.exports = __webpack_public_path__ + "img/laboratorio_16-9_1440.472fa1c9.webp";